/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'image-bold': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M0 7a7 7 0 017-7h18a7 7 0 017 7v18a7 7 0 01-7 7H7a7 7 0 01-7-7V7zm30 0v12.21l-2.043-2.042-.014-.014c-1.02-.981-2.23-1.535-3.506-1.535-1.276 0-2.485.553-3.506 1.535l-1.18 1.182-4.919-4.918-.014-.014c-1.02-.981-2.23-1.535-3.505-1.535-1.277 0-2.486.553-3.507 1.535L2 19.211V7a5 5 0 015-5h18a5 5 0 015 5zm-8.375-.5a2 2 0 100 4h.019a2 2 0 100-4h-.019z" _fill="#A4AAB6"/>'
  }
})
